import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const 	COMPONENT_AUTHORIZATION = "/api/componentAuthorization",//获取平台授权地址	
		PUBILIC_MEMBER_INFO = "/api/getPublicMemberInfo"//获取公众号信息

export default {
	getComponentAuthorizationUrl: ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.get(COMPONENT_AUTHORIZATION)
	},
	getPublicMemberInfo: async ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		const data = await http.get(PUBILIC_MEMBER_INFO)
		commit('PUBILIC_MEMBER_INFO', data)
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/auth/actions.js